// extracted by mini-css-extract-plugin
export var imageUploaderContainer = "image-uploader-module--image-uploader-container--dYCqB";
export var previewImage = "image-uploader-module--preview-image--xFcuI";